import { render } from "./AddNewCar.vue?vue&type=template&id=b27f21e4"
import script from "./AddNewCar.vue?vue&type=script&lang=js"
export * from "./AddNewCar.vue?vue&type=script&lang=js"

import "./AddNewCar.vue?vue&type=style&index=0&id=b27f21e4&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\vue_php_crud\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__